import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Button from 'react-bootstrap/Button';
import { FaBars } from 'react-icons/fa';
import { Helmet } from 'react-helmet-async';
import { useLabels } from '../../hooks/useLabels';
import { usePermissions } from '../../hooks/usePermissions';
import SettingsSidebar, { SidebarNav, SidebarFooter } from './SettingsSidebar';
import './Settings.css';

export default function SettingsLayout() {
	const { t } = useLabels();
	const { canSee, canEdit } = usePermissions();
	const { pathname } = useLocation();
	const [showMobileNav, setShowMobileNav] = useState(false);

	// Close the mobile drawer after navigating.
	useEffect(() => {
		setShowMobileNav(false);
	}, [pathname]);

	if (!canSee() || !canEdit()) {
		return <Navigate to='/AdminScreen' />;
	}

	return (
		<>
			<Helmet>
				<title>{t('settings.title')}</title>
			</Helmet>
			<div className='settings-layout d-flex'>
				<SettingsSidebar />
				<div className='settings-content flex-grow-1'>
					<div className='d-lg-none settings-mobile-bar'>
						<Button
							variant='outline-secondary'
							size='sm'
							onClick={() => setShowMobileNav(true)}
						>
							<FaBars className='me-2' />
							{t('settings.title')}
						</Button>
					</div>
					<Offcanvas
						show={showMobileNav}
						onHide={() => setShowMobileNav(false)}
						placement='start'
						className='settings-offcanvas'
					>
						<Offcanvas.Header closeButton>
							<Offcanvas.Title>{t('settings.title')}</Offcanvas.Title>
						</Offcanvas.Header>
						<Offcanvas.Body className='d-flex flex-column'>
							<SidebarNav />
							<SidebarFooter />
						</Offcanvas.Body>
					</Offcanvas>
					<Outlet />
				</div>
			</div>
		</>
	);
}
